import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import OrderSummary from "../orderSummary/OrderSummary";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCreateOrderMutation } from "../../store/api/OrderSlice";
import toast from "react-hot-toast";
import useDebounce from "../../hooks/useDebounce";
import {
  useFetchAllShippingMethodQuery,
  useFetchShippingByCodeQuery,
} from "../../store/api/ShippingSlice";
import {
  useCheckUserMutation,
  useLoginUserMutation,
  useRegisterUserMutation,
} from "../../store/api/AuthSlice";
import { setAuthData } from "../../store/reducers/auth";
import { isLoginAction } from "../../store/reducers/isOpenSlice";
import States from "../../fakeData/Data";
import AgeChecker from "../login/AgeChecker";

function Checkout() {
  const { data, error, isLoading } = useFetchAllShippingMethodQuery();
  const shippingMethod = data?.find((option) => option.status === "Show");
  const shippingCostNew = shippingMethod?.cost || 0; // Default to 0 if no
  const shippingThreshhold = shippingMethod?.freeShippingThreshold;
  const [createOrder] = useCreateOrderMutation();
  const [PostalCodevalues, setPostalCodevalues] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const navigate = useNavigate();
  const { ...item } = useSelector((state) => state.cart);
  const vendor = item?.cartItems?.[0]?.author?._id || "No Vendor";
  const cartTotalAmount = useSelector((state) => state.cart.cartTotalAmount);

  const finalShippingCost =
    cartTotalAmount >= shippingThreshhold ? 0 : shippingCostNew;

  const [registerUser] = useRegisterUserMutation();
  const [loginUser] = useLoginUserMutation();
  const [checkUser] = useCheckUserMutation();
  const [isAgeVerified, setIsAgeVerified] = useState(false);

  const dispatch = useDispatch();

  // if (!vendor) {
  //   navigate("/");
  //   toast.alert("This Product is out of Stock");
  // }

  const initialValues = {
    name: "",
    email: "",
    phoneNumber: "",
    country: "USA",
    streetAddress: "",
    city: "",
    state: "",
    companyName: "",
    zipCode: "",
    streetAddress2: "",
    city2: "",
    state2: "",
    zipCode2: "",
    // shippingOption: "standard",
    paymentMethod: "credit card",
    cardNumber: "",
    expirationDate: "",
    securityCode: "",
    // author: vendor,
    subTotal: item?.cartTotalAmount,
    shippingCost: shippingCostNew,
    shippingOption: "Credit Card",
    total: item?.cartTotalAmount + shippingCost,
    status: "Processing",
    cart: item,
  };

  // Validation schema using Yup
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Phone number must be 10 digits")
      .required("Phone number is required"),
    country: Yup.string().required("Country is required"),
    streetAddress: Yup.string().required("Street address is required"),
    streetAddress2: Yup.string().required("Street address is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().oneOf(States, "Please select a valid state"),
    city2: Yup.string().required("City is required"),
    state2: Yup.string().oneOf(States, "Please select a valid state"),
    companyName: Yup.string().required("Company name is required"),
    zipCode: Yup.string()
      .matches(/^\d{5}$/, "ZIP/Postal code must be 5 digits")
      .required("ZIP/Postal code is required"),
    zipCode2: Yup.string()
      .matches(/^\d{5}$/, "ZIP/Postal code must be 5 digits")
      .required("ZIP/Postal code is required"),
    sameAsBilling: false,
    shippingOption: Yup.string().required("Shipping option is required"),
    paymentMethod: Yup.string().required("Payment method is required"),
    cardNumber: Yup.string()
     .matches(/^\d{16}$/, "Card number must be exactly 16 digits")
      .required("Card number is required"),
    expirationDate: Yup.string()
      .matches(
        /^(0[1-9]|1[0-2])\/\d{2}$/,
        "Invalid expiration date format (MM/YY)"
      )
      .required("Expiration date is required"),
    securityCode: Yup.string()
      .matches(/^\d{3}$/, "Security code must be 3 digits")
      .required("Security code is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    // onSubmit: async (values) => {
    //   const total = values.subTotal + finalShippingCost;
    //   const email = values.email;
    //   const generatedPassword = "AutoGeneratedPass123"; // move this here

    //   try {
    //     if (!values.name || !values.email) {
    //       toast.error("Name and email are required!");
    //       return;
    //     }

    //     // Step 1: Check if the email already exists
    //     let userId;
    //     const existingUserResponse = await checkUser({
    //       email: values.email,
    //     }).unwrap();

    //     if (existingUserResponse?.data?.exists) {
    //       // If user exists, get the userId
    //       userId = existingUserResponse?.data?.userId;
    //     } else {
    //       // Step 2: Register the user
    //       const registerResponse = await registerUser({
    //         name: values.name,
    //         email: values.email,
    //         password: "AutoGeneratedPass123",
    //       });
    //       userId = registerResponse?.data?._id;
    //     }

    //     // Step 3: Create the order with the userId
    //     const response = await createOrder({
    //       ...values,
    //       userId,
    //       shippingCost: finalShippingCost,
    //       total: total,
    //     }).unwrap();

    //     if (response?.success) {
    //       toast.success("Order placed successfully!");
    //       // Step 4: Auto-login
    //       const loginResponse = await loginUser({
    //         email,
    //         password: generatedPassword,
    //       }).unwrap();

    //       if (
    //         loginResponse?.token &&
    //         loginResponse?.name &&
    //         loginResponse?.email
    //       ) {
    //         dispatch(
    //           setAuthData({
    //             token: loginResponse.token,
    //             user: {
    //               _id: loginResponse._id,
    //               name: loginResponse.name,
    //               email: loginResponse.email,
    //             },
    //           })
    //         );

    //         localStorage.setItem("token", loginResponse.token);
    //         dispatch(isLoginAction(false));
    //       } else {
    //         console.error("Login response missing user data.");
    //       }

    //       // Step 5: Redirect
    //       navigate("/user/dashboard");
    //     } else {
    //       throw new Error("Order submission failed");
    //     }
    //   } catch (error) {
    //     toast.error(`Error: ${error.message}`);
    //   }
    // },
    // onSubmit: async (values) => {
    //   console.log("✅ Form submitted with values:", values);

    //   const total = values.subTotal + finalShippingCost;
    //   const email = values.email;
    //   const generatedPassword = "AutoGeneratedPass123";

    //   // Step 1: Tokenize card data using Accept.js Live
    //   // const authData = {
    //   //   clientKey: "2evEQYJM6bebqEgcCM27K82hQyjy6bUdg3V7e2T6a9PBpX5MDdRwV47Trb3vmvDv", // replace with your real client key
    //   //   apiLoginID: "462qu7AKY", // replace with your real API Login ID
    //   // };

    //   //Testing
    //    const authData = {
    //     clientKey: "42egT6Yz5xp2xgJMv5FRYDrWYUaY5ySzwcRmjs5VQfunExS2Wf9f456xGkA85R94", // replace with your real client key
    //     apiLoginID: "7g45JDR4VxBx", // replace with your real API Login ID
    //   };

    //   console.log("🛡️ Auth Data for Accept.js:", authData);

    //   const [expMonth, expYearShort] = values.expirationDate.split("/");
    //   const cardData = {
    //     cardNumber: values.cardNumber,
    //     month: expMonth,
    //     year: "20" + expYearShort,
    //     cardCode: values.securityCode,
    //   };

    //   console.log("💳 Card Data to tokenize:", cardData);

    //   const secureData = {
    //     authData,
    //     cardData,
    //   };

    //   console.log("🔐 Secure Data passed to Accept.dispatchData:", secureData);

    //   window.Accept.dispatchData(secureData, async function responseHandler(response) {
    //     console.log("📩 Accept.js response:", response);

    //     if (response.messages.resultCode === "Error") {
    //       console.error("❌ Accept.js error response:", response.messages.message);
    //       for (let i = 0; i < response.messages.message.length; i++) {
    //         toast.error(response.messages.message[i].text);
    //       }
    //       return;
    //     }

    //     if (response.opaqueData) {
    //       const opaqueData = response.opaqueData;
    //       console.log("✅ Received opaqueData from Accept.js:", opaqueData);

    //       try {
    //         console.log("🔍 Checking if user exists with email:", email);
    //         let userId;
    //         const existingUserResponse = await checkUser({ email }).unwrap();
    //         console.log("📦 Existing user response:", existingUserResponse);

    //         if (existingUserResponse?.data?.exists) {
    //           userId = existingUserResponse.data.userId;
    //           console.log("👤 Existing user ID:", userId);
    //         } else {
    //           console.log("🆕 Registering new user...");
    //           const registerResponse = await registerUser({
    //             name: values.name,
    //             email,
    //             password: generatedPassword,
    //           }).unwrap();
    //           console.log("📦 Register user response:", registerResponse);
    //           userId = registerResponse?.data?._id;
    //           console.log("👤 New user ID:", userId);
    //         }

    //         //step 2

    //          console.log("🔐 Logging user in immediately...");
    //       const loginResponse = await loginUser({
    //         email,
    //         password: generatedPassword,
    //       }).unwrap();

    //       if (loginResponse?.token) {
    //         localStorage.setItem("token", loginResponse.token);
    //         dispatch(
    //           setAuthData({
    //             token: loginResponse.token,
    //             user: {
    //               _id: loginResponse._id,
    //               name: loginResponse.name,
    //               email: loginResponse.email,
    //             },
    //           })
    //         );
    //         console.log("✅ Token saved, user logged in.");
    //       } else {
    //         throw new Error("Login failed — no token received");
    //       }

    //         // Step 2: Send payment request to backend with opaqueData
    //         const paymentPayload = {
    //           opaqueData,
    //           amount: total,
    //         };

    //         console.log("💸 Sending payment request to backend:", paymentPayload);

    //         const paymentRes = await fetch("http://localhost:5055/api/payment/charge", {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json",
    //           },
    //           body: JSON.stringify(paymentPayload),
    //         });

    //         console.log("🌐 Raw payment response:", paymentRes);

    //         const paymentResult = await paymentRes.json();
    //         console.log("💳 Parsed payment result:", paymentResult);

    //         if (!paymentResult.success) {
    //           throw new Error(paymentResult.error || "Payment failed");
    //         }

    //         // Step 3: Proceed with order creation
    //         const orderPayload = {
    //           ...values,
    //           userId,
    //           shippingCost: finalShippingCost,
    //           total: total,
    //           transactionId: paymentResult.transactionId,
    //         };

    //         console.log("📦 Sending order creation payload:", orderPayload);

    //         const orderResponse = await createOrder(orderPayload).unwrap();
    //         console.log("✅ Order response:", orderResponse);

    //         if (orderResponse?.success) {
    //           toast.success("Order placed successfully!");

    //           console.log("🔐 Logging user in...");
    //           const loginResponse = await loginUser({
    //             email,
    //             password: generatedPassword,
    //           }).unwrap();

    //           console.log("🔓 Login response:", loginResponse);

    //           if (
    //             loginResponse?.token &&
    //             loginResponse?.name &&
    //             loginResponse?.email
    //           ) {
    //             dispatch(
    //               setAuthData({
    //                 token: loginResponse.token,
    //                 user: {
    //                   _id: loginResponse._id,
    //                   name: loginResponse.name,
    //                   email: loginResponse.email,
    //                 },
    //               })
    //             );

    //             localStorage.setItem("token", loginResponse.token);
    //             dispatch(isLoginAction(false));

    //             console.log("🚀 Redirecting to /user/dashboard");
    //             navigate("/user/dashboard");
    //           }
    //         } else {
    //           throw new Error("Order submission failed");
    //         }
    //       } catch (error) {
    //         console.error("🔥 Error caught in payment/order process:", error);
    //         toast.error(`Error: ${error.message}`);
    //       }
    //     } else {
    //       console.error("❌ No opaqueData received from Accept.js");
    //     }
    //   });
    // }

    // onSubmit: async (values) => {
    //   console.log("✅ Form submitted with values:", values);

    //   const total = values.subTotal + finalShippingCost;
    //   const email = values.email;
    //   const generatedPassword = "AutoGeneratedPass123";

    //   // Testing keys for Accept.js
    //   const authData = {
    //     clientKey:
    //       "42egT6Yz5xp2xgJMv5FRYDrWYUaY5ySzwcRmjs5VQfunExS2Wf9f456xGkA85R94",
    //     apiLoginID: "7g45JDR4VxBx",
    //   };

    //   const [expMonth, expYearShort] = values.expirationDate.split("/");
    //   const cardData = {
    //     cardNumber: values.cardNumber,
    //     month: expMonth,
    //     year: "20" + expYearShort,
    //     cardCode: values.securityCode,
    //   };

    //   const secureData = { authData, cardData };

    //   window.Accept.dispatchData(
    //     secureData,
    //     async function responseHandler(response) {
    //       console.log("📩 Accept.js response:", response);

    //       if (response.messages.resultCode === "Error") {
    //         response.messages.message.forEach((msg) => toast.error(msg.text));
    //         return;
    //       }

    //       if (!response.opaqueData) {
    //         console.error("❌ No opaqueData received from Accept.js");
    //         return;
    //       }

    //       const opaqueData = response.opaqueData;
    //       try {
    //         // 1️⃣ Check if user exists
    //         let userId;
    //         const existingUserResponse = await checkUser({ email }).unwrap();
    //         if (existingUserResponse?.data?.exists) {
    //           userId = existingUserResponse.data.userId;
    //         } else {
    //           const registerResponse = await registerUser({
    //             name: values.name,
    //             email,
    //             password: generatedPassword,
    //           }).unwrap();
    //           userId = registerResponse?.data?._id;
    //         }

    //         // 2️⃣ Login once right here
    //         console.log("🔐 Logging user in immediately...");
    //         const loginResponse = await loginUser({
    //           email,
    //           password: generatedPassword,
    //         }).unwrap();
    //         console.log("Login response:", loginResponse);

    //         // ✅ Get token string
    //         const token = loginResponse.token;
    //         if (!token) throw new Error("Login failed — no token received");

    //         // ✅ Save only token as string
    //         localStorage.setItem("token", token);
    //         console.log("TOKEN SENDING:", token); // <-- Add this

    //         dispatch(
    //           setAuthData({
    //             token: loginResponse.token,
    //             user: {
    //               _id: loginResponse._id,
    //               name: loginResponse.name,
    //               email: loginResponse.email,
    //             },
    //           })
    //         );
    //         console.log("✅ Token saved, user logged in.");

    //         // 3️⃣ Send payment request
    //         const paymentPayload = { opaqueData, amount: total };
    //         const paymentRes = await fetch(
    //           "http://localhost:5055/api/payment/charge",
    //           {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(paymentPayload),
    //           }
    //         );
    //         const paymentResult = await paymentRes.json();
    //         if (!paymentResult.success)
    //           throw new Error(paymentResult.error || "Payment failed");

    //         // 4️⃣ Create order
    //         const orderPayload = {
    //           ...values,
    //           userId,
    //           shippingCost: finalShippingCost,
    //           total,
    //           transactionId: paymentResult.transactionId,
    //         };
    //         const orderResponse = await createOrder(orderPayload).unwrap();

    //         if (orderResponse?.success) {
    //           toast.success("Order placed successfully!");
    //           navigate("/user/dashboard");
    //         } else {
    //           throw new Error("Order submission failed");
    //         }
    //       } catch (error) {
    //         console.error("🔥 Error caught in payment/order process:", error);
    //         toast.error(`Error: ${error.message}`);
    //       }
    //     }
    //   );
    // },
    onSubmit: async (values) => {
      console.log("✅ Form submitted with values:", values);

      const total = values.subTotal + finalShippingCost;
      const email = values.email;
      const generatedPassword = "AutoGeneratedPass123";

 const authData = {
        clientKey:
          "2evEQYJM6bebqEgcCM27K82hQyjy6bUdg3V7e2T6a9PBpX5MDdRwV47Trb3vmvDv",
        apiLoginID: "462qu7AKY",
      };

      // Accept.js Auth Keys
      // const authData = {
      //   clientKey:
      //     "42egT6Yz5xp2xgJMv5FRYDrWYUaY5ySzwcRmjs5VQfunExS2Wf9f456xGkA85R94",
      //   apiLoginID: "7g45JDR4VxBx",
      // };

      const [expMonth, expYearShort] = values.expirationDate.split("/");
      const cardData = {
        cardNumber: values.cardNumber,
        month: expMonth,
        year: "20" + expYearShort,
        cardCode: values.securityCode,
      };

      const secureData = { authData, cardData };

      window.Accept.dispatchData(
        secureData,
        async function responseHandler(response) {
          console.log("📩 Accept.js response:", response);

          if (response.messages.resultCode === "Error") {
            response.messages.message.forEach((msg) => toast.error(msg.text));
            return;
          }

          if (!response.opaqueData) {
            console.error("❌ No opaqueData received from Accept.js");
            return;
          }

          const opaqueData = response.opaqueData;

          try {
            // Step 1: Check if user exists
            let userId;

            const existingUserResponse = await checkUser({ email }).unwrap();
            console.log("✅ Existing User Response:", existingUserResponse);

            console.log(
              "✅ Existing User Response Exists:",
              existingUserResponse?.exists
            );
            if (existingUserResponse?.exists) {
              userId = existingUserResponse?.userId;
              console.log("ℹ️ User exists. userId set to:", userId);
            } else {
              // Step 2: Register new user
              const registerResponse = await registerUser({
                name: values.name,
                email,
                password: generatedPassword,
              }).unwrap();

              console.log("✅ Register User Response:", registerResponse);

              userId = registerResponse?._id;

              console.log("ℹ️ User registered. userId set to:", userId);
            }

            // Final check before using userId
            if (!userId) {
              console.error(
                "❌ userId is undefined or null after check/register process"
              );
            } else {
              console.log("✅ Final userId to be used:", userId);
            }
            const items =
              values.cart && values.cart.length > 0
                ? values.cart[0].cartItems
                : [];

            // Step 3: Process payment
            const paymentPayload = {
              opaqueData,
              amount: total,
              name: values.name,
              email: values.email,
              phoneNumber: values.phoneNumber,
              country: values.country,
              streetAddress: values.streetAddress,
              city: values.city,
              state: values.state,
              zipCode: values.zipCode,
              companyName: values.companyName,
              streetAddress2: values.streetAddress2,
              city2: values.city2,
              state2: values.state2,
              zipCode2: values.zipCode2,
              items: items.map((item) => ({
                id: item._id,
                name: item.title,
                description: item.description || item.short_description || "",
                quantity: item.quantity || 1,
                price: item.price || 0,
              })),
            };

            const paymentRes = await fetch(
              // "http://localhost:5055/api/payment/charge",
              "https://api.pufframa.com/api/payment/charge ",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(paymentPayload),
              }
            );
            const paymentResult = await paymentRes.json();

            if (!paymentResult.success) {
              throw new Error(paymentResult.error || "Payment failed");
            }

            // Step 4: Create the order with userId
            const orderResponse = await createOrder({
              ...values,
              userId,
              shippingCost: finalShippingCost,
              total,
              transactionId: paymentResult.transactionId,
            }).unwrap();

            if (!orderResponse?.success) {
              throw new Error("Order submission failed");
            }

            toast.success("Order placed successfully!");

            // Step 5: Auto-login
            const loginResponse = await loginUser({
              email,
              password: generatedPassword,
            }).unwrap();

            if (
              loginResponse?.token &&
              loginResponse?.name &&
              loginResponse?.email
            ) {
              dispatch(
                setAuthData({
                  token: loginResponse.token,
                  user: {
                    _id: loginResponse._id,
                    name: loginResponse.name,
                    email: loginResponse.email,
                  },
                })
              );

              localStorage.setItem("token", loginResponse.token);
              dispatch(isLoginAction(false));
            } else {
              console.error("Login response missing user data.");
            }

            // Step 6: Redirect to dashboard
            navigate("/user/dashboard");
          } catch (error) {
            console.error("🔥 Error caught in payment/order process:", error);
            toast.error(`Error: ${error.message}`);
          }
        }
      );
    },
  });

  useEffect(() => {
    if (localStorage.getItem("isAgeVerified") === "true") {
      setIsAgeVerified(true);
    }
  }, []);
  const PostalCode = useDebounce(PostalCodevalues, 400);

  const ShippingMethods = useFetchShippingByCodeQuery(PostalCode, {
    skip: !PostalCode, // Skip the query if there's no postal code
  });
  return (
    <div className="bg-black-50">
      <AgeChecker />
      <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
        <div className="my-10">
          <div className="mt-5 md:mt-0 md:col-span-2">
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                <div className="lg:col-span-2">
                  {" "}
                  <div>
                    <div>
                      <h2 className="font-semibold text-xl text-base text-black-700 pb-10">
                        Billing Details
                      </h2>
                      <div className="grid grid-cols-6 gap-6">
                        {/* Email Address */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="email"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Email Address <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                                formik.touched.email && formik.errors.email
                                  ? "border-red-500"
                                  : ""
                              }`}
                              id="email"
                              name="email"
                              type="email"
                              placeholder="Enter your email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                          {formik.errors.email && formik.touched.email && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.email}
                            </span>
                          )}
                        </div>

                        {/* First Name */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="email"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                              formik.touched.name && formik.errors.name
                                ? "border-red-500"
                                : ""
                            }`}
                            type="text"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.name && formik.errors.name && (
                            <div className="error">{formik.errors.name}</div>
                          )}
                        </div>

                        {/* Company Name */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="companyName"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Company Name (optional)
                          </label>
                          <div className="relative">
                            <input
                              className="py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12"
                              id="companyName"
                              name="companyName"
                              placeholder=""
                              value={formik.values.companyName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                        </div>

                        {/* Country / Region */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="country"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Country
                          </label>
                          <div className="relative">
                            <select
                              as="select"
                              className="py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12"
                              id="country"
                              name="country"
                              value={formik.values.country}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              <option values="USA">United States</option>
                            </select>
                          </div>

                          {formik.errors.country && formik.touched.country && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.country}
                            </span>
                          )}
                        </div>

                        {/* Street Address */}
                        <div className="col-span-6">
                          <label
                            htmlFor="streetAddress"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Street Address <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                                formik.touched.streetAddress &&
                                formik.errors.streetAddress
                                  ? "border-red-500"
                                  : ""
                              }`}
                              id="streetAddress"
                              name="streetAddress"
                              placeholder="House number and street name"
                              value={formik.values.streetAddress}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                          {formik.errors.streetAddress &&
                            formik.touched.streetAddress && (
                              <span className="text-red-400 text-sm mt-2">
                                {formik.errors.streetAddress}
                              </span>
                            )}
                        </div>
                        {/* City -- Town */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="city"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Town / City <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                                formik.touched.city && formik.errors.city
                                  ? "border-red-500"
                                  : ""
                              }`}
                              id="city"
                              name="city"
                              placeholder="Enter city"
                              value={formik.values.city}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                          {formik.errors.city && formik.touched.city && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.city}
                            </span>
                          )}
                        </div>

                    
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="state"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            State <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <select
                              id="state"
                              name="state"
                              value={formik.values.state}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                                formik.touched.state && formik.errors.state
                                  ? "border-red-500"
                                  : ""
                              }`}
                            >
                              <option value="">Select a state</option>
                              {States.map((state) => (
                                <option key={state} value={state}>
                                  {state}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formik.errors.state && formik.touched.state && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.state}
                            </span>
                          )}
                        </div>


                        {/* ZIP Code */}
                        <div className="col-span-6 sm:col-span-3 ">
                          <label
                            htmlFor="zipCode"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            ZIP / Postal <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                                formik.touched.zipCode && formik.errors.zipCode
                                  ? "border-red-500"
                                  : ""
                              }`}
                              id="zipCode"
                              name="zipCode"
                              placeholder="Enter ZIP/Postal code"
                              value={formik.values.zipCode}
                              onChange={(e) => {
                                formik.handleChange(e); // Formik's handleChange
                                setPostalCodevalues(e.target.value);
                              }}
                              onBlur={formik.handleBlur} // Handle blur event
                            />
                          </div>
                          {formik.errors.zipCode && formik.touched.zipCode && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.zipCode}
                            </span>
                          )}
                        </div>
                        {/* Phone Number */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="phoneNumber"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Phone Number <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                                formik.touched.phoneNumber &&
                                formik.errors.phoneNumber
                                  ? "border-red-500"
                                  : ""
                              }`}
                              id="phoneNumber"
                              name="phoneNumber"
                              placeholder="Enter your phone number"
                              value={formik.values.phoneNumber}
                              onChange={formik.handleChange} // Formik's handleChange
                              onBlur={formik.handleBlur} // Handle blur event
                            />
                          </div>
                          {formik.errors.phoneNumber &&
                            formik.touched.phoneNumber && (
                              <span className="text-red-400 text-sm mt-2">
                                {formik.errors.phoneNumber}
                                {/* Debugging error */}
                              </span>
                            )}
                        </div>
                        {/* -------------------new code ------------------------------- */}

                        <div className="col-span-6">
                          <div className="flex">
                            <label className="block text-black-500 font-semibold font-medium text-xl leading-none mb-2">
                              Ship to the same address
                            </label>
                            <input
                              className="-mt-1 ml-3"
                              type="checkbox"
                              id="sameAsBilling"
                              name="sameAsBilling"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  formik.setValues({
                                    ...formik.values,
                                    streetAddress2: formik.values.streetAddress,
                                    city2: formik.values.city,
                                    state2: formik.values.state,
                                    zipCode2: formik.values.zipCode,
                                  });
                                } else {
                                  formik.setValues({
                                    ...formik.values,
                                    streetAddress2: "",
                                    city2: "",
                                    state2: "",
                                    zipCode2: "",
                                  });
                                }
                              }}
                            />
                          </div>
                        </div>
                        {/* Street Address */}
                        <div className="col-span-6">
                          <h4 className="pb-6">Shipping Details</h4>
                          <label
                            htmlFor="shippingStreetAddress"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2 mt-4"
                          >
                            Street Address <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                              formik.touched.streetAddress2 &&
                              formik.errors.streetAddress2
                                ? "border-red-500"
                                : ""
                            }`}
                            id="streetAddress2"
                            name="streetAddress2"
                            placeholder="House number and street name"
                            value={formik.values.streetAddress2}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.streetAddress2 &&
                            formik.errors.streetAddress2 && (
                              <p className="text-red-500 text-sm mt-1">
                                {formik.errors.streetAddress2}
                              </p>
                            )}
                        </div>

                        {/* City */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="shippingCity"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Town / City <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                              formik.touched.city2 && formik.errors.city2
                                ? "border-red-500"
                                : ""
                            }`}
                            id="city2"
                            name="city2"
                            placeholder="Enter city"
                            value={formik.values.city2}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.city2 && formik.errors.city2 && (
                            <p className="text-red-500 text-sm mt-1">
                              {formik.errors.city2}
                            </p>
                          )}
                        </div>

                        {/* State */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="shippingState"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            State<span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <select
                              id="state2"
                              name="state2"
                              value={formik.values.state2}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                                formik.touched.state2 && formik.errors.state2
                                  ? "border-red-500"
                                  : ""
                              }`}
                            >
                              <option value="">Select a state</option>
                              {States.map((state) => (
                                <option key={state} value={state}>
                                  {state}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formik.errors.state2 && formik.touched.state2 && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.state2}
                            </span>
                          )}
                        </div>

                        {/* ZIP Code */}
                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                          <label
                            htmlFor="shippingZipCode"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            ZIP / Postal <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${
                              formik.touched.zipCode2 && formik.errors.zipCode2
                                ? "border-red-500"
                                : ""
                            }`}
                            id="zipCode2"
                            name="zipCode2"
                            placeholder="Enter ZIP/Postal code"
                            value={formik.values.zipCode2}
                            onChange={(e) => formik.handleChange(e)}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.zipCode2 &&
                            formik.errors.zipCode2 && (
                              <p className="text-red-500 text-sm mt-1">
                                {formik.errors.zipCode2}
                              </p>
                            )}
                        </div>
                      </div>
                      {/* Shipping Cost---- */}
                      <div className="hidden mt-2 mb-2">
                        <label className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2">
                          Shipping Cost
                        </label>
                        <div className="hidden grid grid-cols-6 gap-6">
                          {data &&
                            data
                              .filter((option) => option.status === "Show")
                              .map((option, index) => (
                                <div
                                  key={index}
                                  className="col-span-6 sm:col-span-3"
                                >
                                  <div className="p-3 border border-black-200 bg-white rounded-md">
                                    <label className="cursor-pointer label">
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                          <span className="text-2xl mr-3 text-black-400">
                                            {/* SVG Icon */}
                                          </span>
                                          <div>
                                            <h6 className="font-medium text-sm text-black-600">
                                              {option.name || "Shipping Option"}{" "}
                                              {/* Option name */}
                                            </h6>
                                            <p className="text-xs text-black-500 font-semibold font-medium">
                                              <span className="font-medium text-black-600">
                                                {option.cost
                                                  ? `$ ${option.cost}`
                                                  : " $ 0"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <span className="text-black-600 font-medium">
                                          {formik.values.shippingOption ===
                                          option.id
                                            ? "Selected"
                                            : ""}
                                        </span>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              ))}
                        </div>

                        {formik.errors.shippingOption &&
                          formik.touched.shippingOption && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.shippingOption}
                            </span>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-1 lg:mr-6">
                  <OrderSummary class
                    shippingCost={shippingCostNew}
                    threshold={shippingThreshhold}
                    formik={formik}
                  />
                  <div className=" w-full lg:ml-14  mx-auto mt-8 bg-white shadow-lg rounded-xl overflow-hidden border border-black-100">
                    {/* Header */}
                    <div className="bg-black-50 px-6 py-4 border-b border-black-200">
                      <h2 className="text-lg font-semibold text-black-800">
                        Payment Details
                      </h2>
                      <p className="text-sm text-black-500 font-semibold">
                        Secure payment with SSL encryption
                      </p>
                    </div>

                    {/* Form Content */}
                    <div className="p-6 space-y-5">
                      {/* Payment Method */}
                      <div>
                        <label
                          htmlFor="paymentMethod"
                          className="block text-sm font-medium text-black-700 mb-1"
                        >
                          Payment Method <span className="text-red-500">*</span>
                        </label>
                        <select
                          id="paymentMethod"
                          name="paymentMethod"
                          value={formik.values.paymentMethod}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className={`block w-full rounded-lg border ${
                            formik.touched.paymentMethod &&
                            formik.errors.paymentMethod
                              ? "border-red-500"
                              : "border-black-300"
                          } bg-white py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                        >
                          <option value="">Select payment method</option>
                          <option value="credit card">💳 Credit Card</option>
                        </select>
                        {formik.touched.paymentMethod &&
                          formik.errors.paymentMethod && (
                            <p className="text-red-500 text-xs mt-1">
                              {formik.errors.paymentMethod}
                            </p>
                          )}
                      </div>

                      {/* Card Number */}
                      <div>
                        <label
                          htmlFor="cardNumber"
                          className="block text-sm font-medium text-black-700 mb-1"
                        >
                          Card Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="cardNumber"
                          name="cardNumber"
                          placeholder="1234 5678 9012 3456"
                          value={formik.values.cardNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className={`block w-full rounded-lg border ${
                            formik.touched.cardNumber &&
                            formik.errors.cardNumber
                              ? "border-red-500"
                              : "border-black-300"
                          } py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                        />
                        {formik.touched.cardNumber &&
                          formik.errors.cardNumber && (
                            <p className="text-red-500 text-xs mt-1">
                              {formik.errors.cardNumber}
                            </p>
                          )}
                      </div>

                      {/* Expiration & CVV */}
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label
                            htmlFor="expirationDate"
                            className="block text-sm font-medium text-black-700 mb-1"
                          >
                            Expiration (MM/YY){" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="expirationDate"
                            name="expirationDate"
                            placeholder="MM/YY"
                            maxLength={5} // Prevent extra characters
                            value={formik.values.expirationDate}
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric chars
                              if (value.length >= 3) {
                                value =
                                  value.slice(0, 2) + "/" + value.slice(2, 4);
                              }
                              formik.setFieldValue("expirationDate", value);
                            }}
                            onBlur={formik.handleBlur}
                            className={`block w-full rounded-lg border ${
                              formik.touched.expirationDate &&
                              formik.errors.expirationDate
                                ? "border-red-500"
                                : "border-black-300"
                            } py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                          />
                          {formik.touched.expirationDate &&
                            formik.errors.expirationDate && (
                              <p className="text-red-500 text-xs mt-1">
                                {formik.errors.expirationDate}
                              </p>
                            )}
                        </div>

                        <div>
                          <label
                            htmlFor="securityCode"
                            className="block text-sm font-medium text-black-700 mb-1 "
                          >
                            CVV <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="password"
                            id="securityCode"
                            name="securityCode"
                            placeholder="•••"
                            value={formik.values.securityCode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={`block w-full rounded-lg border ${
                              formik.touched.securityCode &&
                              formik.errors.securityCode
                                ? "border-red-500"
                                : "border-black-300"
                            } py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                          />
                          {formik.touched.securityCode &&
                            formik.errors.securityCode && (
                              <p className="text-red-500 text-xs mt-1">
                                {formik.errors.securityCode}
                              </p>
                            )}
                        </div>
                      </div>

                      {/* Pay Button */}
                      <div className="col-span-6 sm:col-span-3">
                        <button
                          type="submit"
                          id="checkout-button"
                           onClick={() => {
    // Simulate click on hidden dummy to trigger AgeChecker popup
    const hiddenTrigger = document.getElementById("fake-age-checker");
    if (hiddenTrigger) hiddenTrigger.click();
                           }}
                          className="bg-emerald-500 hover:bg-emerald-600 border border-emerald-500 transition-all rounded py-3 text-center text-sm  font-medium text-white flex justify-center w-full"
                        >
                          Place Order
                          <span className="text-xl ml-2">
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth="0"
                              viewBox="0 0 512 512"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="48"
                                d="M268 112l144 144-144 144m124-144H100"
                              ></path>
                            </svg>
                          </span>
                          <div id="fake-age-checker" style={{ display: "none" }}></div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* --------------------------------------card details-------------------- */}

              {/* ----------------- Payment Details Section ----------------- */}

              {/* <div className="grid grid-cols-6 gap-4 lg:gap-6 mt-10">
                <div className="col-span-6 sm:col-span-3">
                  <Link
                    className="bg-indigo-50 border !no-underline border-indigo-100 rounded py-3 text-center text-sm font-medium !text-black-700  hover:!text-black-800 hover:border-black-300 transition-all flex justify-center w-full"
                    to="/"
                  >
                    <span className="text-xl mr-2">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M112 160l-64 64 64 64"
                        ></path>
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M64 224h294c58.76 0 106 49.33 106 108v20"
                        ></path>
                      </svg>
                    </span>
                    Continue Shopping
                  </Link>
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Checkout;
